var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-app',{attrs:{"id":"pwt-optimiser"}},[_c('v-main',{staticClass:"pa-1 pa-sm-3",attrs:{"id":"pwt-main-container"}},[(_vm.showLogin)?_c('LoginOverlay'):_vm._e(),_c('MapPanel'),_c('InfoPanelControls'),_c('MainDialog'),_c('SecondaryDialog'),_c('TertiaryDialog')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }